import { generateChecksum as c } from "@allmaps/id";
import { validateMap as o, parseAnnotation as d } from "@allmaps/annotation";
import I from "./RTree.js";
import { bboxToCenter as p, combineBboxes as h } from "@allmaps/stdlib";
import { WarpedMapEvent as i, WarpedMapEventType as a } from "../shared/events.js";
function f() {
  return {
    createRTree: !0,
    imageInformations: /* @__PURE__ */ new Map()
  };
}
class g extends EventTarget {
  warpedMapFactory;
  warpedMapsById = /* @__PURE__ */ new Map();
  zIndices = /* @__PURE__ */ new Map();
  rtree;
  imageInformations;
  transformation;
  fetchFn;
  /**
   * Creates an instance of a WarpedMapList.
   *
   * @constructor
   * @param {WarpedMapFactory<W>} [warpedMapFactory] - Factory function for creating WarpedMap objects
   * @param {WarpedMapListOptions} [options] - Options
   */
  constructor(e, t) {
    super(), this.warpedMapFactory = e, t = {
      ...f(),
      ...t
    }, this.fetchFn = t?.fetchFn, this.imageInformations = t.imageInformations, this.transformation = t.transformation, t.createRTree && (this.rtree = new I());
  }
  /**
   * Returns mapIds for the maps in this list.
   *
   * @returns {Iterable<string>}
   */
  getMapIds() {
    return this.warpedMapsById.keys();
  }
  getWarpedMaps(e) {
    if (e === void 0)
      return this.warpedMapsById.values();
    {
      const t = [];
      for (const s of e) {
        const n = this.warpedMapsById.get(s);
        n && t.push(n);
      }
      return t;
    }
  }
  /**
   * Returns the WarpedMap object in this list of map specified by its ID.
   *
   * @param {string} mapId
   * @returns {(W | undefined)}
   */
  getWarpedMap(e) {
    return this.warpedMapsById.get(e);
  }
  /**
   * Returns the z-index of a map.
   *
   * @param {string} mapId
   * @returns {number | undefined}
   */
  getMapZIndex(e) {
    return this.zIndices.get(e);
  }
  getCenter() {
    const e = this.getBbox();
    if (e)
      return p(e);
  }
  getProjectedCenter() {
    const e = this.getProjectedBbox();
    if (e)
      return p(e);
  }
  /**
   * Return the bounding box of all visible maps in this list, in longitude/latitude coordinates
   *
   * @returns {(Bbox | undefined)}
   */
  getBbox() {
    let e;
    for (const t of this.getWarpedMaps())
      t.visible && (e ? e = h(e, t.geoMaskBbox) : e = t.geoMaskBbox);
    return e;
  }
  /**
   * Return the bounding box of all visible maps in this list, in projected coordinates
   *
   * @returns {(Bbox | undefined)}
   */
  getProjectedBbox() {
    let e;
    for (const t of this.getWarpedMaps())
      t.visible && (e ? e = h(e, t.projectedGeoMaskBbox) : e = t.projectedGeoMaskBbox);
    return e;
  }
  /**
   * Returns mapIds of the maps whose geoBbox overlaps with the specified geoBbox.
   *
   * @param {Bbox} geoBbox
   * @returns {Iterable<string>}
   */
  getMapsByGeoBbox(e) {
    return this.rtree ? this.rtree.searchFromBbox(e) : Array.from(this.warpedMapsById.keys());
  }
  /**
   * Sets the object that caches image information
   *
   * @param {ImageInformations} imageInformations - object that caches image information
   */
  setImageInformations(e) {
    this.imageInformations = e;
  }
  /**
   * Sets the resource mask for a specified map
   *
   * @param {string} mapId - ID of the map
   * @param {Ring} resourceMask - the new resource mask
   */
  setMapResourceMask(e, t) {
    const s = this.warpedMapsById.get(e);
    s && (s.setResourceMask(t), this.addToOrUpdateRtree(s), this.dispatchEvent(
      new i(a.RESOURCEMASKUPDATED, e)
    ));
  }
  /**
   * Sets the transformation type of specified maps
   *
   * @param {Iterable<string>} mapIds - the IDs of the maps
   * @param {TransformationType} transformationType - the new transformation type
   */
  setMapsTransformationType(e, t) {
    const s = [];
    for (const n of e) {
      const r = this.warpedMapsById.get(n);
      r && r.transformationType != t && s.push(n);
    }
    s.length > 0 && (this.dispatchEvent(
      new i(a.PRECHANGE, s)
    ), s.forEach((n) => {
      const r = this.warpedMapsById.get(n);
      r && (r.setTransformationType(t), this.addToOrUpdateRtree(r));
    }), this.dispatchEvent(
      new i(
        a.TRANSFORMATIONCHANGED,
        s
      )
    ));
  }
  /**
   * Sets the distortion measure of specified maps
   *
   * @param {Iterable<string>} mapIds - the IDs of the maps
   * @param {DistortionMeasure} [distortionMeasure] - the distortion measure
   */
  setMapsDistortionMeasure(e, t) {
    const s = [];
    for (const n of e) {
      const r = this.warpedMapsById.get(n);
      r && r.distortionMeasure != t && s.push(n);
    }
    s.length > 0 && (this.dispatchEvent(
      new i(a.PRECHANGE, s)
    ), s.forEach((n) => {
      const r = this.warpedMapsById.get(n);
      r && (r.setDistortionMeasure(t), this.addToOrUpdateRtree(r));
    }), this.dispatchEvent(
      new i(a.DISTORTIONCHANGED, s)
    ));
  }
  /**
   * Changes the z-index of the specified maps to bring them to front
   *
   * @param {Iterable<string>} mapIds
   */
  bringMapsToFront(e) {
    let t = this.warpedMapsById.size;
    for (const s of e)
      this.zIndices.has(s) && (this.zIndices.set(s, t), t++);
    this.removeZIndexHoles(), this.dispatchEvent(new i(a.ZINDICESCHANGED));
  }
  /**
   * Changes the z-index of the specified maps to send them to back
   *
   * @param {Iterable<string>} mapIds
   */
  sendMapsToBack(e) {
    let t = -Array.from(e).length;
    for (const s of e)
      this.zIndices.has(s) && (this.zIndices.set(s, t), t++);
    this.removeZIndexHoles(), this.dispatchEvent(new i(a.ZINDICESCHANGED));
  }
  /**
   * Changes the z-index of the specified maps to bring them forward
   *
   * @param {Iterable<string>} mapIds
   */
  bringMapsForward(e) {
    for (const [t, s] of this.zIndices.entries())
      this.zIndices.set(t, s * 2);
    for (const t of e) {
      const s = this.zIndices.get(t);
      s !== void 0 && this.zIndices.set(t, s + 3);
    }
    this.removeZIndexHoles(), this.dispatchEvent(new i(a.ZINDICESCHANGED));
  }
  /**
   * Changes the zIndex of the specified maps to send them backward
   *
   * @param {Iterable<string>} mapIds
   */
  sendMapsBackward(e) {
    for (const [t, s] of this.zIndices.entries())
      this.zIndices.set(t, s * 2);
    for (const t of e) {
      const s = this.zIndices.get(t);
      s !== void 0 && this.zIndices.set(t, s - 3);
    }
    this.removeZIndexHoles(), this.dispatchEvent(new i(a.ZINDICESCHANGED));
  }
  /**
   * Changes the visibility of the specified maps to `true`
   *
   * @param {Iterable<string>} mapIds
   */
  showMaps(e) {
    for (const t of e) {
      const s = this.warpedMapsById.get(t);
      s && (s.visible = !0);
    }
    this.dispatchEvent(
      new i(a.VISIBILITYCHANGED, e)
    );
  }
  /**
   * Changes the visibility of the specified maps to `false`
   *
   * @param {Iterable<string>} mapIds
   */
  hideMaps(e) {
    for (const t of e) {
      const s = this.warpedMapsById.get(t);
      s && (s.visible = !1);
    }
    this.dispatchEvent(
      new i(a.VISIBILITYCHANGED, e)
    );
  }
  /**
   * Adds a georeferenced map to this list
   *
   * @async
   * @param {unknown} georeferencedMap
   * @returns {Promise<string | Error>}
   */
  async addGeoreferencedMap(e) {
    const t = o(e), s = Array.isArray(
      t
    ) ? t[0] : t;
    return this.addGeoreferencedMapInternal(s);
  }
  /**
   * Removes a georeferenced map from this list
   *
   * @async
   * @param {unknown} georeferencedMap
   * @returns {Promise<string | Error>}
   */
  async removeGeoreferencedMap(e) {
    const t = o(e), s = Array.isArray(
      t
    ) ? t[0] : t;
    return this.removeGeoreferencedMapInternal(s);
  }
  /**
   * Parses an annotation and adds its georeferenced map to this list
   *
   * @async
   * @param {unknown} annotation
   * @returns {Promise<(string | Error)[]>}
   */
  async addGeoreferenceAnnotation(e) {
    const t = [], s = d(e), n = await Promise.allSettled(
      s.map((r) => this.addGeoreferencedMapInternal(r))
    );
    for (const r of n)
      r.status === "fulfilled" ? t.push(r.value) : t.push(r.reason);
    return this.dispatchEvent(
      new i(a.GEOREFERENCEANNOTATIONADDED)
    ), this.dispatchEvent(new i(a.ZINDICESCHANGED)), t;
  }
  /**
   * Parses an annotation and removes its georeferenced map from this list
   *
   * @async
   * @param {unknown} annotation
   * @returns {Promise<(string | Error)[]>}
   */
  async removeGeoreferenceAnnotation(e) {
    const t = [], s = d(e);
    for (const n of s) {
      const r = await this.removeGeoreferencedMapInternal(n);
      t.push(r);
    }
    return this.dispatchEvent(
      new i(a.GEOREFERENCEANNOTATIONREMOVED)
    ), t;
  }
  clear() {
    this.warpedMapsById = /* @__PURE__ */ new Map(), this.zIndices = /* @__PURE__ */ new Map(), this.rtree?.clear(), this.dispatchEvent(new i(a.CLEARED));
  }
  destroy() {
    for (const e of this.getWarpedMaps())
      this.removeEventListenersFromWarpedMap(e), e.destroy();
    this.clear();
  }
  async addGeoreferencedMapInternal(e) {
    const t = await this.getOrComputeMapId(e), s = this.warpedMapFactory(t, e, {
      imageInformations: this.imageInformations,
      fetchFn: this.fetchFn,
      transformation: this.transformation
    });
    return this.warpedMapsById.set(t, s), this.zIndices.set(t, this.warpedMapsById.size - 1), this.addToOrUpdateRtree(s), this.addEventListenersToWarpedMap(s), this.dispatchEvent(
      new i(a.WARPEDMAPADDED, t)
    ), t;
  }
  async removeGeoreferencedMapInternal(e) {
    const t = await this.getOrComputeMapId(e), s = this.warpedMapsById.get(t);
    if (s)
      this.warpedMapsById.delete(t), this.zIndices.delete(t), this.removeFromRtree(s), this.dispatchEvent(
        new i(a.WARPEDMAPREMOVED, t)
      ), this.removeZIndexHoles(), this.dispatchEvent(new i(a.ZINDICESCHANGED)), s.destroy();
    else
      throw new Error(`No map found with ID ${t}`);
    return t;
  }
  async getOrComputeMapId(e) {
    return e.id || await c(e);
  }
  addToOrUpdateRtree(e) {
    this.rtree && (this.rtree.removeItem(e.mapId), this.rtree.addItem(e.mapId, e.geoMask));
  }
  removeFromRtree(e) {
    this.rtree && this.rtree.removeItem(e.mapId);
  }
  removeZIndexHoles() {
    const e = [...this.zIndices.entries()].sort(
      (s, n) => s[1] - n[1]
    );
    let t = 0;
    for (const s of e) {
      const n = s[0];
      this.zIndices.set(n, t), t++;
    }
  }
  // This function and the listeners below transform an IMAGEINFOLOADED event by a WarpedMap
  // to an IMAGEINFOLOADED of the WarpedMapList, which is listened to in the Renderer
  imageInfoLoaded() {
    this.dispatchEvent(new i(a.IMAGEINFOLOADED));
  }
  addEventListenersToWarpedMap(e) {
    e.addEventListener(
      a.IMAGEINFOLOADED,
      this.imageInfoLoaded.bind(this)
    );
  }
  removeEventListenersFromWarpedMap(e) {
    e.removeEventListener(
      a.IMAGEINFOLOADED,
      this.imageInfoLoaded.bind(this)
    );
  }
}
export {
  g as default
};
//# sourceMappingURL=WarpedMapList.js.map
